import {
  ChangeDetectionStrategy,
  Component,
  ContentChildren,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Optional,
  Output,
  QueryList,
  Self,
  SimpleChanges
} from '@angular/core';
import { ControlValueAccessor, FormControl, NgControl } from '@angular/forms';
import { BUI_ICON_TYPE_MDI, BuiIconMaterial, isBuiIconMaterialIconType } from '@base/utils/icon-types.util';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ValidationErrorDirective } from '@shared/components/form-elements/directives/validation-error.directive';
import { isRequired } from '@shared/components/form-elements/form-elements.util';
import { HIDE_REQUIRED_MARKER } from '@shared/util/form.util';

@UntilDestroy()
@Component({
  selector: 'app-input-text',
  templateUrl: './input-text.component.html',
  styleUrls: ['./input-text.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InputTextComponent implements ControlValueAccessor, OnInit, OnChanges {
  @Input() label: string;
  @Input() placeholder = '';
  @Input() tooltip: string;
  @Input() tabindex: number;
  @Input() prefix: string;
  @Input() prefixType: 'noSpaceString' | BuiIconMaterial = BUI_ICON_TYPE_MDI;
  @Input() suffix: string;
  @Input() suffixType: 'spinner' | BuiIconMaterial = BUI_ICON_TYPE_MDI;
  @Input() suffixTabindex: number;
  @Input() isSuffixClickable: boolean;
  @Input() textSize: 'normal' | 'large' = 'normal';
  @Input() isFullWide: boolean;
  @Input() disabled: boolean;
  @Input() type: 'password' | 'text' | 'time' = 'text';
  @Input() inputAlignment: 'left' | 'right' = 'left';
  @Input() autocomplete: 'on' | 'off' = 'on';
  @Output() suffixClickEvent: EventEmitter<any> = new EventEmitter<any>();

  protected readonly isBuiIconMaterialIconType = isBuiIconMaterialIconType;
  defaultFormControl = new FormControl();
  required: boolean;
  hideRequiredMarker = HIDE_REQUIRED_MARKER;

  changeFn;

  @ContentChildren(ValidationErrorDirective) validationErrors: QueryList<ValidationErrorDirective>;

  constructor(@Self() @Optional() public ngControl: NgControl) {
    if (ngControl) {
      ngControl.valueAccessor = this;
    }
  }

  ngOnInit(): void {
    this.required = isRequired(this.ngControl);

    if (this.ngControl) {
      this.ngControl.statusChanges
        .pipe(untilDestroyed(this))
        .subscribe(() => this.required = isRequired(this.ngControl));
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.disabled) {
      if (this.disabled) {
        this.ngControl?.control?.disable();
      }
    }
  }

  onFocus(event: any): void {
    event?.target?.select();
  }

  onInput(event: any): void {
    if (this.changeFn) {
      this.changeFn(event.target.value);
    }
  }

  registerOnChange(fn: any): void {
    this.changeFn = fn;
  }

  registerOnTouched(): void {
  }

  setDisabledState(): void {
  }

  writeValue(val: string): void {
  }

  suffixClicked(event: any): void {
    this.suffixClickEvent.emit(event);
  }

  clear(): void {
    this.ngControl?.control?.setValue('');
  }
}
